module.exports = __webpack_public_path__ + "img/empty-cart.74fe990a.svg";